import { Backdrop, CircularProgress } from '@mui/material';
import "flickity/css/flickity.css";
import moment from 'jalali-moment';
import { useEffect, useState } from 'react';
import Flickity from "react-flickity-component";
import { Link } from 'react-router-dom';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import FrequencyQuestions from '../components/FrequencyQuestions';
import Gallery from '../components/Gallery';
import Nav from '../components/Nav';
import Services from '../components/Services';
import { getDepartmentInfo, getScenario } from './../api/routes';
import AboutUs from './../components/AboutUs';

export default function Home() {
    const [departmentInfo, setDepartmentInfo] = useState();
    const [open, setOpen] = useState(false);
    const [scenarios, setScenarios] = useState([]);

    const m = moment()
    m.locale('fa');

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        handleOpen()
        getDepartmentInfo((isOk, data) => {
            if (!isOk) {
                handleClose()
                return alert(data.message);
            }
            else {
                handleClose()
                return setDepartmentInfo(data)
            }
        })
        sessionStorage.clear()
    }, [])
    useEffect(() => {
        getScenario(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return alert(data.message);
            else return setScenarios(data)
        })
    }, [])

    let times = []
    for (let i = 0; i < scenarios.length; i++) {
        times.push({ reservationDate: scenarios[i].reservationDate, times: [{ from: scenarios[i]?.startTime, to: scenarios[i]?.endTime }] })
    }

    let newScenarios = [];
    times.forEach(function (item) {
        let existing = newScenarios.filter(function (v, i) {
            return v.reservationDate === item.reservationDate;
        });

        if (existing.length) {
            let existingIndex = newScenarios.indexOf(existing[0]);
            newScenarios[existingIndex].times = newScenarios[existingIndex].times.concat(item.times);
        } else {
            if (typeof item.times == 'string')
                item.times = [item.times];
            newScenarios.push(item);
        }
    });



    return (
        <>

            <div className="relative hero-carousel overflow-hidden pt-6">
                <header className="relative container mx-auto px-4">
                    <Nav logo={departmentInfo && departmentInfo[0].logo} />

                    <div className="h-[70px] lg:h-[110px]" />

                    <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                        {/* TEXT (LEFT on lg) */}
                        <div className="order-2 lg:order-1">
                            {/* top badge */}
                            <div className="flex justify-center lg:justify-start">
                                <span className="px-5 py-2 rounded-full text-xs font-extrabold bg-[#0ea5b7] text-white shadow-[0_10px_22px_rgba(2,132,199,0.18)]">
                                    ارائه دهنده خدمات تصویربرداری و تشخیصی
                                </span>
                            </div>

                            {/* tags */}
                            <div className="mt-4 flex flex-wrap gap-2 items-center justify-center lg:justify-start">
                                <span className="px-3 py-1 rounded-full text-xs font-bold bg-[#e8fbff] text-[#067d8a] ring-1 ring-[#bfefff]/60">
                                    مرکز تصویربرداری پزشکی عارف
                                </span>
                                <span className="px-3 py-1 rounded-full text-xs font-bold bg-[#eefdf4] text-[#15803d] ring-1 ring-[#bbf7d0]/70">
                                    CT • MRI • سونوگرافی • رادیولوژی
                                </span>
                            </div>

                            {/* TITLE */}
                            <h1 className="mt-6 text-center lg:text-right text-[30px] sm:text-[42px] xl:text-[52px] font-black leading-[1.1] text-slate-900 tracking-tight">
                                تصویربرداری دقیق برای تشخیص سریع و مطمئن
                            </h1>

                            {/* DESCRIPTION */}
                            <p className="mt-5 text-center lg:text-right text-sm sm:text-base text-slate-600 leading-8 max-w-[560px] mx-auto lg:mx-0">
                                با بهره‌گیری از دستگاه‌های پیشرفته تصویربرداری پزشکی و تیم متخصص،
                                خدمات CT اسکن، MRI، سونوگرافی و رادیولوژی دیجیتال را با دقت بالا،
                                زمان انتظار کم و گزارش تخصصی ارائه می‌دهیم.
                            </p>

                            {/* SCENARIO CARDS */}
                            <div className="mt-8">
                                <Flickity
                                    className="w-full"
                                    options={{
                                        prevNextButtons: true,
                                        groupCells: 1,
                                        pageDots: false,
                                        rightToLeft: true,
                                        initialIndex: 0,
                                        contain: true,
                                        adaptiveHeight: false,
                                        setGallerySize: true,
                                    }}
                                >
                                    {newScenarios.map((scenario, index) => {
                                        const dateText = moment(
                                            `${String(scenario.reservationDate).slice(0, 4)}/${String(
                                                scenario.reservationDate
                                            ).slice(4, 6)}/${String(scenario.reservationDate).slice(6)}`,
                                            "jYYYY/jM/jD"
                                        )
                                            .locale("fa")
                                            .format("LLLL")
                                            .slice(0, -11);

                                        const shownTimes = scenario.times.slice(0, 5);

                                        return (
                                            <Link key={index} to="/reservation" className="ml-4 block">
                                                <section
                                                    className="
                      relative group w-[178px] sm:w-[230px] h-[190px] sm:h-[230px]
                      rounded-[30px] sm:rounded-[40px] overflow-hidden
                      border border-white/30
                      bg-white/60 backdrop-blur-[18px]
                      shadow-[0_10px_30px_rgba(2,132,199,0.12)]
                      ring-1 ring-[#9be9ff]/40
                      transition-all duration-300
                      hover:-translate-y-[3px]
                      hover:shadow-[0_20px_50px_rgba(2,132,199,0.18)]
                      hover:ring-[#06b6d4]/70

                      before:absolute before:inset-0 before:rounded-[inherit]
                      before:bg-gradient-to-b before:from-white/40 before:to-white/5
                      before:pointer-events-none
                    "
                                                >
                                                    {/* Softer top line */}
                                                    <div className="h-[3px] w-full opacity-70 bg-gradient-to-r from-[#06b6d4]/80 via-[#22c55e]/70 to-[#3b82f6]/80" />

                                                    {/* Softer glows */}
                                                    <div className="pointer-events-none absolute -top-16 -right-16 h-40 w-40 rounded-full bg-[#9be9ff] blur-[90px] opacity-25 group-hover:opacity-35 transition duration-300" />
                                                    <div className="pointer-events-none absolute -bottom-20 -left-16 h-44 w-44 rounded-full bg-[#bbf7d0] blur-[100px] opacity-20 group-hover:opacity-28 transition duration-300" />

                                                    <div className="relative px-4 pt-4 pb-4 h-full flex flex-col">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#e8fbff] ring-1 ring-[#bfefff]/60 text-[#0284c7] text-sm">
                                                                📅
                                                            </span>
                                                            <p className="text-[12px] sm:text-sm font-extrabold text-[#075985] text-center">
                                                                {dateText}
                                                            </p>
                                                        </div>

                                                        <div className="mt-3 flex flex-wrap justify-center gap-2">
                                                            {shownTimes.map((time, index2) => (
                                                                <span
                                                                    key={index2}
                                                                    className="px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold bg-white/70 text-slate-700 ring-1 ring-black/5 shadow-[0_6px_14px_rgba(0,0,0,0.06)]"
                                                                >
                                                                    {time.from} - {time.to}
                                                                </span>
                                                            ))}

                                                            {scenario.times.length > 5 && (
                                                                <span className="px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold bg-[#fff1f5] text-[#e11d48] ring-1 ring-[#ffd3df]/80">
                                                                    +{scenario.times.length - 5} بیشتر
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="mt-auto pt-3 flex items-center justify-between">
                                                            <span className="text-[10px] sm:text-xs font-bold text-slate-500">
                                                                {scenario.times.length} بازه زمانی
                                                            </span>

                                                            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-extrabold bg-[#e8fbff] text-[#036672] ring-1 ring-[#bfefff]/60 shadow-[0_8px_18px_rgba(2,132,199,0.10)] group-hover:bg-[#06b6d4] group-hover:text-white group-hover:ring-[#06b6d4]/70 transition duration-300">
                                                                رزرو آنلاین
                                                                <span className="transition duration-300 group-hover:translate-x-0.5">
                                                                    ←
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </section>
                                            </Link>
                                        );
                                    })}
                                </Flickity>
                            </div>
                        </div>

                        {/* IMAGE (RIGHT on lg) */}
                        <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
                            <div className="relative w-[92%] sm:w-[520px]">
                                {/* image */}
                                {departmentInfo && departmentInfo[0] && (
                                    <div
                                        className="
                relative rounded-[44px] overflow-hidden
                bg-white ring-1 ring-black/4
             
              "
                                    >
                                        <img
                                            loading="lazy"
                                            src={
                                                departmentInfo
                                                    ? `data:image/jpeg;base64,${departmentInfo[0].headerImage}`
                                                    : ""
                                            }
                                            alt="radiology center"
                                            className="w-full h-[420px] sm:h-[520px] object-cover"
                                        />
                                    </div>
                                )}

                                {/* bottom floating stats */}
                                <div className="absolute -bottom-7 left-6 right-6 bg-white/70 backdrop-blur-[16px] border border-white/40 shadow-[0_10px_30px_rgba(0,0,0,0.08)] rounded-3xl p-5">
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="flex items-center justify-center gap-3">
                                            <p className="text-2xl font-black text-[#0ea5b7]">98%</p>
                                            <div className="text-right">
                                                <p className="text-xs text-slate-500">میزان رضایت</p>
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-center gap-3">
                                            <p className="text-2xl font-black text-[#0ea5b7]">+25K</p>
                                            <div className="text-right">
                                                <p className="text-xs text-slate-500">مراجعین سالانه</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* glow */}
                                <div className="pointer-events-none absolute -inset-10 rounded-[60px] bg-[#9be9ff] blur-[120px] opacity-20 -z-10" />
                            </div>
                        </div>
                    </section>

                    <div className="h-10 lg:h-16" />
                </header>
            </div>

            <Services />
            <AboutUs aboutText={departmentInfo && departmentInfo[0].aboutText} aboutImage={departmentInfo && departmentInfo[0].aboutImage} />
            <Gallery />
            <FrequencyQuestions />
            <ContactUs data={departmentInfo && departmentInfo[0]} />
            <Footer data={departmentInfo && departmentInfo[0]} />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}
